import React, { useRef } from 'react';
import {
	Button,
	Div,
	InputGroup,
	Typography,
} from '@icecreamsocial/components';
import { CopyIcon } from '../SupportedIcons';
import { WebShareButton } from '..';
import { useIntl } from 'react-intl';

export const ShareLink = ({
	link,
	label,
	text,
	onCopy = () => null,
	...rest
}) => {
	const OVERFLOW_STYLES = { whiteSpace: 'nowrap', textOverflow: 'ellipsis' };
	const linkRef = useRef(null);
	const intl = useIntl();

	/**
	 * localization
	 */
	const COPY = intl.formatMessage({
		id: 'button.copy',
		defaultMessage: 'Copy',
		description: 'Call to action text to copy a link',
	});

	/**
	 * simple memoized implementation of copying based on https://www.w3schools.com/howto/howto_js_copy_clipboard.asp
	 * @param {function} onCopy callback once copy is called
	 */
	const copy = async () => {
		linkRef.current.select();
		linkRef.current.setSelectionRange(0, 99999); // for mobile

		document.execCommand('copy');

		onCopy(linkRef.current.value);
	};

	return (
		<Div display='flex' alignItems='center' style={{ gap: '8px' }}>
			<InputGroup display='block' elWidth='100%' {...rest}>
				{label && <InputGroup.Label>{label}</InputGroup.Label>}
				<InputGroup.Fields backgroundColor='ambient' padding='sm' border='none'>
					<InputGroup.Input
						ref={linkRef}
						value={link}
						marginLeft='sm'
						textDecoration='underline'
						elWidth='100%'
						overflow='hidden'
						style={OVERFLOW_STYLES}
						readOnly
					/>

					<Button
						type='button'
						display='flex'
						alignItems='center'
						backgroundColor={['transparent', 'transparent', 'accent']}
						textColor={['accent', 'accent', 'bodyInverse']}
						borderRadius={['40px', '40px', '32px']}
						paddingLeft={['md']}
						paddingRight={['md']}
						shadow='none'
						style={{ gap: '8px' }}
						onClick={copy}
					>
						<CopyIcon size={18} />
						<Typography.Span
							display={[
								navigator.share ? 'none' : 'block',
								navigator.share ? 'none' : 'block',
								'inline',
							]}
						>
							{COPY}
						</Typography.Span>
					</Button>
					{navigator.share && (
						<WebShareButton borderRadius='32px' marginLeft='sm' link={link} />
					)}
				</InputGroup.Fields>
			</InputGroup>
		</Div>
	);
};
